import { FC, useState } from "react";

interface IBreakdownObject {
  header: string;
  list?: string[];
}

interface ISolutionProps {
  header: string;
  img: string | undefined;
  content: string;
  breakdown: IBreakdownObject[];
  even: boolean;
}

export const Solution: FC<ISolutionProps> = ({
  header,
  img,
  content,
  breakdown,
  even,
}) => {
  const [solution, setSolution] = useState(false);
  return (
    <div
      className={`Solution Solutions__body__solution Solution-${header.replace(
        /\s/g,
        "-"
      )}`}
      id={`Solution-${header.replace(/\s/g, "-")}`}
    >
      <h2 className="section-header">{header}</h2>
      <div className="Solutions__body__solution__content">
        <div
          className={`Solutions__body__solution__content__inner ${
            even ? "inner-even" : "inner-odd"
          }`}
        >
          <img src={img} alt="" />
          <p>{content}</p>
        </div>
        <div className="cta">
          <button
            onClick={() => {
              setSolution(!solution);
            }}
            className="cta__btn cta__btn-green-outline"
          >
            <span>View Details</span>
            <i
              className={`fas ${
                solution ? "fa-chevron-up" : "fa-chevron-down"
              }`}
            ></i>
          </button>
        </div>
        <div
          className={`Solutions__body__solution__content__breakdown ${
            solution ? "flex" : "hide"
          }`}
        >
          {breakdown.map((obj) => {
            if (obj.list) {
              return (
                <>
                  <h3>{obj.header}</h3>
                  <ul>
                    {obj.list.map((li) => {
                      return <li>{li}</li>;
                    })}
                  </ul>
                </>
              );
            } else {
              return <h3>{obj.header}</h3>;
            }
          })}
        </div>
      </div>
    </div>
  );
};
